import React from "react";
import {IListViewField} from "../../../../Shared/ILIstViewField";
import {OldNewDocumentListView} from "../../../../Shared/NewDocumentTabView";
import {AppEntities} from "../../../../../config/entities";

const GoodsRegardingsList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <OldNewDocumentListView fields={fields} entity={AppEntities.GoodsRegardings} />
        </>
    );
}

export default GoodsRegardingsList;